module.exports = __webpack_public_path__ + "static/media/goal_flag_blue.2418fc10.svg";